import { FiCreditCard, FiLock, FiSmartphone } from 'react-icons/fi'
import Button from './ui/Button'
import { getPaymentMethodDisplay } from '../utils/billingType'

const PaymentMethodBlock = ({
  paymentMethod,
  cancelled = false,
  canUpdateCard = false,
  onUpdateCard,
  variant = 'panel',
}) => {
  if (!paymentMethod?.billingType) return null

  const display = getPaymentMethodDisplay(paymentMethod, { cancelled })
  const isCard = display.type === 'CREDIT_CARD'
  const isPix = display.type === 'PIX'
  const Icon = isPix ? FiSmartphone : FiCreditCard

  if (variant === 'sidebar') {
    return (
      <div>
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-accent/10 dark:bg-accent/20 text-accent">
            <Icon className="w-5 h-5" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-extrabold text-gray-900 dark:text-white">{display.title}</p>
            {display.masked && (
              <p className="mt-1 font-mono text-sm tracking-wider text-gray-700 dark:text-gray-200">
                {display.masked}
              </p>
            )}
            {display.subtitle && (
              <p className="mt-1 text-xs text-gray-600 dark:text-gray-400 leading-relaxed">{display.subtitle}</p>
            )}
          </div>
        </div>
        {display.securityNote && (
          <p className="mt-3 flex items-start gap-2 text-[11px] text-gray-500 dark:text-gray-400 leading-relaxed">
            <FiLock className="w-3.5 h-3.5 shrink-0 mt-0.5 text-accent/80" aria-hidden="true" />
            <span>{display.securityNote}</span>
          </p>
        )}
        {canUpdateCard && onUpdateCard && (
          <Button
            type="button"
            variant="secondary"
            size="md"
            className="w-full mt-4"
            onClick={onUpdateCard}
          >
            Trocar cartão
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className="mb-5 rounded-2xl border border-gray-200 dark:border-gray-700 bg-gray-50/80 dark:bg-gray-800/50 p-4">
      <p className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-[0.2em] mb-3">
        Forma de pagamento
      </p>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-start gap-3 min-w-0">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-accent/10 dark:bg-accent/20 text-accent">
            <Icon className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-extrabold text-gray-900 dark:text-white">{display.title}</p>
            {display.masked && (
              <p className="mt-0.5 font-mono text-sm tracking-wider text-gray-700 dark:text-gray-200">
                {display.masked}
              </p>
            )}
            {display.subtitle && (
              <p
                className={`mt-1 text-xs leading-relaxed ${
                  cancelled ? 'text-amber-700 dark:text-amber-300' : 'text-gray-600 dark:text-gray-400'
                }`}
              >
                {display.subtitle}
              </p>
            )}
            {display.securityNote && isCard && !cancelled && (
              <p className="mt-2 flex items-start gap-1.5 text-[11px] text-gray-500 dark:text-gray-400 leading-relaxed">
                <FiLock className="w-3.5 h-3.5 shrink-0 mt-0.5" aria-hidden="true" />
                <span>{display.securityNote}</span>
              </p>
            )}
          </div>
        </div>
        {canUpdateCard && onUpdateCard && (
          <Button
            type="button"
            variant="secondary"
            size="md"
            className="w-full sm:w-auto shrink-0"
            onClick={onUpdateCard}
          >
            Trocar cartão
          </Button>
        )}
      </div>
    </div>
  )
}

export default PaymentMethodBlock
